<template>
  <component
    :is="component"
    v-if="exists"
    v-bind="$attrs"
    :class="classes"
    v-on="$listeners"
  />
</template>

<script>
import kebabCase from 'lodash/kebabCase';

import classes from '~~/common/vue/mixins/classes';

// TODO: import these dynamically
// large
import TouchShowL from '~~/common/vue/components/icons/l/touch-show.svg';
import CheckCircleL from '~~/common/vue/components/icons/l/check-circle.svg';
import CoinsL from '~~/common/vue/components/icons/l/coins.svg';

// medium
import ArrowDownM from '~~/common/vue/components/icons/m/arrow-down.svg';
import AtlasM from '~~/common/vue/components/icons/m/atlas.svg';
import GlobeM from '~~/common/vue/components/icons/m/globe.svg';
import CenterPositionM from '~~/common/vue/components/icons/m/centre-position.svg';
import CheckCircleM from '~~/common/vue/components/icons/m/check-circle.svg';
import CheckCircleOutlineM from '~~/common/vue/components/icons/m/check-circle-outline.svg';
import CheckCircleTransparentM from '~~/common/vue/components/icons/m/check-circle-transparent.svg';
import CheckM from '~~/common/vue/components/icons/m/check.svg';
import ChevronLeftM from '~~/common/vue/components/icons/m/chevron-left.svg';
import ChevronRightM from '~~/common/vue/components/icons/m/chevron-right.svg';
import CloseM from '~~/common/vue/components/icons/m/close.svg';
import ExclamationCircleM from '~~/common/vue/components/icons/m/exclamation-circle.svg';
import EllipsisM from '~~/common/vue/components/icons/m/ellipsis.svg';
import HamburgerM from '~~/common/vue/components/icons/m/hamburger.svg';
import LeafM from '~~/common/vue/components/icons/m/leaf.svg';
import LogoCompactM from '~~/common/vue/components/icons/m/logo-compact.svg';
import MinusM from '~~/common/vue/components/icons/m/minus.svg';
import PlusM from '~~/common/vue/components/icons/m/plus.svg';
import QuestionCircleM from '~~/common/vue/components/icons/m/question-circle.svg';
import SearchM from '~~/common/vue/components/icons/m/search.svg';
import SpinnerM from '~~/common/vue/components/icons/m/spinner.svg';
import WhatsAroundM from '~~/common/vue/components/icons/m/whats-around.svg';
import BlogM from '~~/common/vue/components/icons/m/social/blog.svg';
import FacebookM from '~~/common/vue/components/icons/m/social/facebook.svg';
import FossilFuelM from '~~/common/vue/components/icons/m/fossil-fuel.svg';
import InstagramM from '~~/common/vue/components/icons/m/social/instagram.svg';
import YoutubeM from '~~/common/vue/components/icons/m/social/youtube.svg';
import LinkedinM from '~~/common/vue/components/icons/m/social/linkedin.svg';
import RetryM from '~~/common/vue/components/icons/m/retry.svg';
import TwitterM from '~~/common/vue/components/icons/m/social/twitter.svg';
import ShoppingLeafM from '~~/common/vue/components/icons/m/shopping-leaf.svg';
import SourceBingM from '~~/common/vue/components/icons/m/external/source-bing.svg';
import SourceAmazonM from '~~/common/vue/components/icons/m/external/source-amazon.svg';
import SourceEcosiaM from '~~/common/vue/components/icons/m/external/source-ecosia.svg';
import SourceGoogleM from '~~/common/vue/components/icons/m/external/source-google.svg';
import SourceGoogleMapsM from '~~/common/vue/components/icons/m/external/source-google-maps.svg';
import SourceTreedayM from '~~/common/vue/components/icons/m/external/source-treeday.svg';
import SourceTripadvisorM from '~~/common/vue/components/icons/m/external/source-tripadvisor.svg';
import SourceYoutubeM from '~~/common/vue/components/icons/m/external/source-youtube.svg';
import SourceWikipediaM from '~~/common/vue/components/icons/m/external/source-wikipedia.svg';

// small
import AtlasS from '~~/common/vue/components/icons/s/atlas.svg';
import ArrowRightS from '~~/common/vue/components/icons/s/arrow-right.svg';
import CheckS from '~~/common/vue/components/icons/s/check.svg';
import CheckCircleS from '~~/common/vue/components/icons/s/check-circle.svg';
import CheckCircleTransparentS from '~~/common/vue/components/icons/s/check-circle-transparent.svg';
import ChevronDownS from '~~/common/vue/components/icons/s/chevron-down.svg';
import ChevronMiniDownS from '~~/common/vue/components/icons/s/chevron-mini-down.svg';
import ChevronLeftS from '~~/common/vue/components/icons/s/chevron-left.svg';
import ChevronRightS from '~~/common/vue/components/icons/s/chevron-right.svg';
import ChevronUpS from '~~/common/vue/components/icons/s/chevron-up.svg';
import ChevronMiniUpS from '~~/common/vue/components/icons/s/chevron-mini-up.svg';
import CloseS from '~~/common/vue/components/icons/s/close.svg';
import ExclamationCircleS from '~~/common/vue/components/icons/s/exclamation-circle.svg';
import GlobeS from '~~/common/vue/components/icons/s/globe.svg';
import InfoCircleS from '~~/common/vue/components/icons/s/info-circle.svg';
import MapPinS from '~~/common/vue/components/icons/s/map-pin.svg';
import MinusS from '~~/common/vue/components/icons/s/minus.svg';
import PhoneS from '~~/common/vue/components/icons/s/phone.svg';
import PlayS from '~~/common/vue/components/icons/s/play.svg';
import PlusS from '~~/common/vue/components/icons/s/plus.svg';
import QuestionCircleS from '~~/common/vue/components/icons/s/question-circle.svg';
import ReviewsS from '~~/common/vue/components/icons/s/reviews.svg';
import SearchS from '~~/common/vue/components/icons/s/search.svg';
import ImagesS from '~~/common/vue/components/icons/s/images.svg';
import MapsS from '~~/common/vue/components/icons/s/maps.svg';
import MoreS from '~~/common/vue/components/icons/s/more.svg';
import NewsS from '~~/common/vue/components/icons/s/news.svg';
import VideosS from '~~/common/vue/components/icons/s/videos.svg';
import RetryS from '~~/common/vue/components/icons/s/retry.svg';
import StarFillS from '~~/common/vue/components/icons/s/star-fill.svg';
import StarHalfS from '~~/common/vue/components/icons/s/star-half.svg';
import StarS from '~~/common/vue/components/icons/s/star.svg';
import TripadvisorRatingFillS from '~~/common/vue/components/icons/s/ta-rating-fill.svg';
import TripadvisorRatingHalfS from '~~/common/vue/components/icons/s/ta-rating-half.svg';
import TripadvisorRatingS from '~~/common/vue/components/icons/s/ta-rating.svg';
import TimeS from '~~/common/vue/components/icons/s/time.svg';
import WhatsAroundS from '~~/common/vue/components/icons/s/whats-around.svg';
import FacebookS from '~~/common/vue/components/icons/s/social/facebook.svg';
import InstagramS from '~~/common/vue/components/icons/s/social/instagram.svg';
import YoutubeS from '~~/common/vue/components/icons/s/social/youtube.svg';
import LinkedinS from '~~/common/vue/components/icons/s/social/linkedin.svg';
import TwitterS from '~~/common/vue/components/icons/s/social/twitter.svg';
import SearchMiniS from '~~/common/vue/components/icons/s/search-mini.svg';
import ShoppingS from '~~/common/vue/components/icons/s/shopping.svg';

// aliases
const WebS = SearchMiniS;
const ChevronMiniDownM = ChevronMiniDownS;
const ChevronMiniUpM = ChevronMiniUpS;

const large = {
  TouchShowL,
  CheckCircleL,
  CoinsL
};
const medium = {
  ArrowDownM,
  AtlasM,
  GlobeM,
  CenterPositionM,
  CheckCircleM,
  CheckCircleOutlineM,
  CheckCircleTransparentM,
  CheckM,
  ChevronLeftM,
  ChevronRightM,
  ChevronMiniDownM,
  ChevronMiniUpM,
  CloseM,
  EllipsisM,
  ExclamationCircleM,
  BlogM,
  FacebookM,
  FossilFuelM,
  HamburgerM,
  InstagramM,
  LeafM,
  LinkedinM,
  LogoCompactM,
  MinusM,
  PlusM,
  QuestionCircleM,
  RetryM,
  SearchM,
  SpinnerM,
  TwitterM,
  WhatsAroundM,
  YoutubeM,
  ShoppingLeafM,
  SourceAmazonM,
  SourceBingM,
  SourceEcosiaM,
  SourceGoogleM,
  SourceGoogleMapsM,
  SourceTreedayM,
  SourceTripadvisorM,
  SourceWikipediaM,
  SourceYoutubeM,
};
const small = {
  AtlasS,
  ArrowRightS,
  CheckS,
  CheckCircleS,
  CheckCircleTransparentS,
  ChevronDownS,
  ChevronLeftS,
  ChevronMiniDownS,
  ChevronMiniUpS,
  ChevronRightS,
  ChevronUpS,
  CloseS,
  ExclamationCircleS,
  FacebookS,
  GlobeS,
  InfoCircleS,
  InstagramS,
  LinkedinS,
  MapPinS,
  MinusS,
  PhoneS,
  PlayS,
  PlusS,
  QuestionCircleS,
  RetryS,
  ReviewsS,
  SearchS,
  ShoppingS,
  MoreS,
  ImagesS,
  MapsS,
  NewsS,
  VideosS,
  WebS,
  StarFillS,
  StarHalfS,
  StarS,
  TimeS,
  TripadvisorRatingFillS,
  TripadvisorRatingHalfS,
  TripadvisorRatingS,
  TwitterS,
  WhatsAroundS,
  YoutubeS,
};
const components = {
  ...large,
  ...medium,
  ...small,
};

export const icons = Object.keys(components).map(kebabCase);
export const sizes = ['s', 'm', 'l'];

export default {
  name: 'EIcon',
  components,
  mixins: [classes],
  props: {
    /**
     * available icons, see examples
     */
    icon: {
      type: String,
      required: true,
      cssClass: true,
    },
    /**
     * `s, m, l`
     */
    size: {
      type: String,
      default: 'm',
      validator: (value) => sizes.includes(value),
      cssClass: true,
    },
  },
  computed: {
    component() {
      return `${this.icon}-${this.size}`;
    },
    exists() {
      const exists = icons.includes(this.component);
      if (!exists) {
        // eslint-disable-next-line no-console
        console.error(`${this.component} icon component does not exist.`);
      }
      return exists;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  vertical-align: middle;

  &.icon--icon-check-circle.icon--size-l path {
    animation: e-svg-stroke 0.5s ease-out forwards;
    stroke-dasharray: 29;
    stroke-dashoffset: 29;
  }

  &--icon-spinner {
    animation: e-spin 0.5s linear both infinite;
  }
}
</style>

<docs>
```js
<div>
  <div>
    <EIcon icon="chevron-left" />
    <EIcon icon="source-google-maps" />
    <EIcon icon="close" />
    <EIcon icon="minus" />
    <EIcon icon="plus" />
    <EIcon icon="question-circle" />
    <EIcon icon="exclamation-circle" />
    <EIcon icon="spinner" />
  </div>
  <div>
    <EIcon icon="chevron-left" size="s" />
    <EIcon icon="close" size="s" />
    <EIcon icon="exclamation-circle" size="s" />
    <EIcon icon="globe" size="s" />
    <EIcon icon="info-alt" size="s" />
    <EIcon icon="map-pin" size="s" />
    <EIcon icon="minus" size="s" />
    <EIcon icon="phone" size="s" />
    <EIcon icon="plus" size="s" />
    <EIcon icon="question-circle" size="s" />
    <EIcon icon="reviews" size="s" />
    <EIcon icon="star-fill" size="s" />
    <EIcon icon="star" size="s" />
    <EIcon icon="time" size="s" />
    <EIcon icon="search" size="s" />
    <EIcon icon="images" />
    <EIcon icon="maps" />
    <EIcon icon="news" />
    <EIcon icon="videos" />
  </div>
</div>
```
</docs>
